module.exports = __webpack_public_path__ + "71f22516dee909cb04efc08d7f1e6d1b.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/3.svg
// module id = 622
// module chunks = 0